/**
 * Patterns are defined by the opacity level or the intensity of the LED.
 * Each LED is represented by a single element with each array (0-6)
 * Each array of LED intensity would be considered a animation frame.
 * Animations will loop so make sure that that they are continous.
 *
 * Animations can be given a
 */

const animationList = {
  openClose: [
    [0, 0, 0, 1, 0, 0, 0],
    [0, 0, 1, 0, 1, 0, 0],
    [0, 1, 0, 0, 0, 1, 0],
    [1, 0, 0, 0, 0, 0, 1],
    [0, 1, 0, 0, 0, 1, 0],
    [0, 0, 1, 0, 1, 0, 0],
    [0, 0, 0, 1, 0, 0, 0],
  ],
  smallToBig: [
    [0, 0, 0, 1, 0, 0, 0],
    [0, 0, 1, 1, 1, 0, 0],
    [0, 1, 1, 1, 1, 1, 0],
    [1, 1, 1, 1, 1, 1, 1],
    [0, 1, 1, 1, 1, 1, 0],
    [0, 0, 1, 1, 1, 0, 0],
    [0, 0, 0, 1, 0, 0, 0],
  ],
  blink: [
    [0, 0, 0, 0, 0, 0, 0],
    [1, 1, 1, 1, 1, 1, 1],
  ],
  pulse: [
    [0, 0, 0, 0, 0, 0, 0],
    [0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5],
    [1, 1, 1, 1, 1, 1, 1],
    [0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5],
  ],
  chase: [
    [0, 0, 0.5, 1, 0.5, 0, 0],
    [0, 0.5, 1, 0.5, 0, 0, 0],
    [0.5, 1, 0.5, 0, 0, 0, 0],
    [0, 0.5, 1, 0.5, 0, 0, 0],
    [0, 0, 0.5, 1, 0.5, 0, 0],
    [0, 0, 0, 0.5, 1, 0.5, 0],
    [0, 0, 0, 0, 0.5, 1, 0.5],
    [0, 0, 0, 0.5, 1, 0.5, 0],
  ],
  off: [[0, 0, 0, 0, 0, 0, 0]],
  clear: [[0, 0, 0, 0, 0, 0, 0]],
  solid: [[1, 1, 1, 1, 1, 1, 1]],
  falling: [
    [1, 0, 0, 0, 1, 0, 0],
    [0, 1, 0, 0, 0, 1, 0],
    [0, 0, 1, 0, 0, 0, 1],
    [0, 0, 0, 1, 0, 0, 0],
  ],
  rising: [
    [0, 0, 0, 1, 0, 0, 0],
    [0, 0, 1, 0, 0, 0, 1],
    [0, 1, 0, 0, 0, 1, 0],
    [1, 0, 0, 0, 1, 0, 0],
  ],
  //[0, 0.25, 0.25, 0.5, 1, 0.5, 0.25, 0.25]
  // aurora: [
  //   [0, 0.25, 0.5, 1, 0.5, 0.25, 0],
  //   [0, 0, 0.25, 0.5, 1, 0.5, 0.25],
  //   [0.25, 0, 0, 0.25, 0.5, 1, 0.5],
  //   [0.5, 0.25, 0, 0, 0.25, 0.5, 1],
  //   [1, 0.5, 0.25, 0, 0, 0.25, 0.5],
  //   [0.5, 1, 0.5, 0.25, 0, 0, 0.25],
  //   [0.25, 0.5, 1, 0.5, 0.25, 0, 0],
  // ],
  aurora: [
    [0, 0.25, 0.25, 0.5, 1, 0.5, 0.25],
    [0.25, 0, 0.25, 0.25, 0.5, 1, 0.5],
    [0.25, 0.25, 0, 0.25, 0.25, 0.5, 1],
    [0.5, 0.25, 0.25, 0, 0.25, 0.25, 0.5],
    [1, 0.5, 0.25, 0.25, 0, 0.25, 0.25],
    [0.5, 1, 0.5, 0.25, 0.25, 0, 0.25],
    [0.25, 0.5, 1, 0.5, 0.25, 0.25, 0],
    [0.25, 0.25, 0.5, 1, 0.5, 0.25, 0.25],
  ],
  siren: [
    [1, 1, 1, 1, 1, 1, 1],
    [0, 1, 1, 1, 1, 1, 0],
  ],
};

export default animationList;
